import { useState, useEffect } from "react";
import { Modal } from "./Modal";

interface ConfirmOptions {
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
}

interface ConfirmProps {
    setConfirm?: (value: boolean) => void;
    showConfirm?: boolean;
    setShowConfirm?: (value: boolean) => void;

    isOpen?: boolean;
    onConfirm?: (confirmed: boolean) => void;
    onClose?: () => void;
    options?: ConfirmOptions;
}

export function Confirm({
    setConfirm,
    showConfirm = false,
    setShowConfirm,
    isOpen,
    onConfirm,
    onClose,
    options = {}
}: ConfirmProps): JSX.Element {
    const [isModalOpen, setIsModalOpen] = useState(showConfirm ?? false);
    const modalIsOpen = isOpen !== undefined ? isOpen : isModalOpen;
    const title = options.title || "Confirm";
    const message = options.message || "Any unsaved changes will be lost.";
    const confirmText = options.confirmText || "Leave";
    const cancelText = options.cancelText || "Stay";

    useEffect(() => {
        if (showConfirm !== undefined) {
            setIsModalOpen(showConfirm);
        }
    }, [showConfirm]);

    const stay = () => {
        if (onConfirm) {
            onConfirm(false);
        } else {
            setIsModalOpen(false);
            if (setConfirm) setConfirm(false);
            if (setShowConfirm) setShowConfirm(false);
        }
    };

    const leave = () => {
        if (onConfirm) {
            onConfirm(true);
        } else {
            setIsModalOpen(false);
            if (setConfirm) setConfirm(true);
            if (setShowConfirm) setShowConfirm(false);
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            setIsModalOpen(false);
            if (setConfirm) setConfirm(false);
            if (setShowConfirm) setShowConfirm(false);
        }
    };


    return (
        <Modal isOpen={modalIsOpen} onClose={handleClose} title={title}>
            <div className="space-y-4 text-base mt-8">
                <div>
                    <br />
                    <p className="text-center">
                        {message}
                    </p>

                    <div className="flex justify-end gap-4 mt-12">
                        <button className="w-32 py-2 px-4 rounded-full bg-good-green text-white" onClick={stay}>{cancelText}</button>
                        <button className="w-32 py-2 px-4 rounded-full bg-bad-red text-white" onClick={leave}>{confirmText}</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
